import storage from 'common/services/storage'

export const ACCESS_TOKEN_KEY = 'pico_token'
export const REFRESH_TOKEN_KEY = 'pico_refresh_token'

export function saveToken(message, token) {
    if (token) {
        if (message === 'TOKEN/STORE/REFRESH') {
            storage.set(REFRESH_TOKEN_KEY, token)
        } else if (message === 'TOKEN/STORE/ACCESS') {
            storage.set(ACCESS_TOKEN_KEY, token)
        }
    }
}

export function removeToken(message) {
    if (message === 'TOKEN/REMOVE/ACCESS') {
        storage.remove(ACCESS_TOKEN_KEY)
    } else if (message === 'TOKEN/REMOVE/REFRESH') {
        storage.remove(REFRESH_TOKEN_KEY)
    }
}

export function getRefreshToken() {
    const refresh_token = storage.get(REFRESH_TOKEN_KEY)

    if (!refresh_token) {
        return null
    }

    return refresh_token.replace(/['"]+/g, '')
}

export function getAccessToken() {
    const access_token = storage.get(ACCESS_TOKEN_KEY)

    if (!access_token) {
        return null
    }

    return access_token.replace(/['"]+/g, '')
}
